import styled from '@emotion/styled';

const bg = (props) => (props.bg ? { 'background-color': props.bg } : null);

export const Box = styled.div`
    width: 100%;
    padding: 10px;
    ${bg};
`;

Box.displayName = 'Box';
